exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#message-field .md-field.md-has-value .md-textarea{font-size:13px}.image-viewer-dialog .md-dialog-container{width:auto!important;height:auto!important}.md-dialog-content.md-theme-default{display:flex}.email-dialog .md-dialog-container{width:auto!important;height:auto!important}.qr-block{display:flex;flex-direction:row;align-items:center}.qr-block img{margin-left:5px;margin-top:5px}.mes textarea{min-height:100%;max-height:100%;resize:none;flex-grow:1}.new-message-block{display:flex}.attach-label{margin-left:5px}.attach-controls span,.attach-header{font-size:.8rem}.attach-header{position:absolute;right:17px;top:15px}.new-message-block .md-field{margin:0;padding:5px;border-radius:5px;border:1px solid #d3d3d3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./Components/supportNew/messages.vue
// module id = 429
// module chunks = 0